{
  "User not found": "Hittade inte användaren",
  "About me": "Om mig",
  "Not available": "Kommer inom kort",
  "Settings": "Inställningar",
  "Preferred language": "Välj språk",
  "You need to enter a first and last name": "Du måste fylla i ditt för- och efternamn",
  "There were errors when trying to update your name:": "Det uppstod ett fel när vi skulle uppdatera ditt namn:",
  "Saving language failed.": "Vi kunde inte spara ditt val av språk",
  "Your name": "Namn",
  "First name": "Förnamn",
  "Last name": "Efternamn",
  "Save": "Spara",
  "Request password": "Begär lösenord",
  "There is no password set for this account.": "Det här kontot saknar lösenord",
  "Use the link below to request a password": "Använd länken nedan för att begära lösenord",
  "Verification email sent.": "En verifiering har skickats med e-post",
  "Change password": "Ändra lösenord",
  "Passwords do not match": "Lösenorden överensstämmer inte",
  "old password": "Gammalt lösenord",
  "new password": "Nytt lösenord",
  "repeat password": "Upprepa lösenord",
  "Password updated": "Ditt lösenord har uppdaterats",
  "Update password": "Uppdatera lösenord",
  "Roles": "Roller",
  "Id": "ID",
  "Space": "Utrymme",
  "Try again later.": "Försök igen senare.",
  "If the issue persists, please contact support.": "Kontakta support om problemet kvarstår",
  "Password settings": "Lösenord",
  "password-change-email-sent": "Ett E-postmeddelande med instruktioner för hur du ändrar lösenord har skickats till {{email}}.\nOm du inte fått någon e-post, försök igen eller kontakta support"
}
